import {OnInit, AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {AppService} from "@api";
import {ColaboradorEvaluacionModalComponent} from "@contenido/AppContent/global/colaboradorevaluacion/colaboradorevaluacion.component";
import {RespuestaEstatusEnum} from "@enumeraciones/Enumeraciones.enum";
import {AlertaEnum, DialogoEnum} from "@mensaje/Enumeraciones/MensajeEnumeraciones.enum";
import {MensajeService} from "@mensaje/Mensaje.Service";
import {AsignacionEvaluacion} from "@modelo/proceso/asignacionevaluacion.model";
import {PeriodoEvaluacion} from "@modelo/proceso/periodoevaluacion.model";
import {TranslateService} from "@ngx-translate/core";
import {SistemaService} from "@servicios/Sistema.Service";


@Component({
    selector: 'asignacionevaluacioncolaborador',
    templateUrl: './asignacionevaluacioncolaborador.component.html',
    styleUrls: ['../asignacionevaluacion.component.scss']
})

export class AsignacionEvaluacionColaboradorComponent implements OnInit, AfterViewInit {
    consulta!: boolean;
    entidad: PeriodoEvaluacion;
    asignacionentidad: AsignacionEvaluacion;
    asignacionentidadrepuesto: AsignacionEvaluacion;
    @Input() accion!: {accion: string, entidad: any};
    @Input() id!: number;
    @Input() identificador!: number;
    @Output() output = new EventEmitter();
    public animacion!: string;
    public abierto!: boolean;
    public errorActivo!: boolean;
    cambio: boolean = false;
    activar: boolean = false;
    visualizar: boolean = false;

    colaboradorinfo: any;
    organigrama: any;
    listatotal:any[] = [];

    colaboradorpar: any[];
    listcolaboradores: any[];
    listgrupocolaboradores: any[];
    SelDepartamento: any[];

    DataColaboradoresComplementarias: any[];
    DataColaboradores: any[]


    @ViewChild('colaborador') private colaborador!: ColaboradorEvaluacionModalComponent;

    constructor(private appService: AppService, public sistemaService: SistemaService, public translate: TranslateService, private mensajeService: MensajeService, public _cfr: ComponentFactoryResolver) {
        this.entidad = new PeriodoEvaluacion();
        this.asignacionentidad = new AsignacionEvaluacion();
        this.asignacionentidadrepuesto = new AsignacionEvaluacion();

        this.DataColaboradoresComplementarias = [];
        this.DataColaboradores = [];

        this.listgrupocolaboradores = [];
        this.colaboradorpar = [];
        this.listcolaboradores = [];
        this.SelDepartamento = [];

    }

    ngOnInit() {
        if (this.identificador == 2) {
            this.visualizar = true;
        }
    }

    ngAfterViewInit() {
        this.SetPeriodoEvaluacion();
        if (this.sistemaService.permisos.edicionespecial) {
            this.SetDepartamento();
        } else {
            this.SetDepartamentoColaborador();
        }
    }

    SetPeriodoEvaluacion() {
        this.appService.Post("planeacion/periodoevaluacion/buscar", {"periodoevaluacionid": this.id}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.entidad = new PeriodoEvaluacion(res.data[0]);
            }
        })
    }

    SetDepartamentoColaborador() {
        this.appService.Get("configuracionrh/departamento/usuario/").then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.asignacionentidad = new AsignacionEvaluacion();
                this.SelDepartamento = res.data
                this.asignacionentidad.departamentoid = res.data[0].departamentoid;
                this.SetColaboradoresGrupoDetalle(res.data[0].departamentoid);
            }
        })
    }

    SetDepartamento() {
        this.appService.Post("configuracionrh/departamento/buscar", {"activo": 1}).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.asignacionentidad = new AsignacionEvaluacion();
                this.SelDepartamento = res.data
                let departamentotodos = {"departamentoid": 0, "nombre": "Todos"}
                this.SelDepartamento.unshift(departamentotodos)
                this.SetColaboradoresGrupo(0);
            }
        })
    }

    SetColaboradores(e: any) {
        this.listgrupocolaboradores = [];
        this.DataColaboradores = [];
        this.DataColaboradoresComplementarias = [];
        this.asignacionentidadrepuesto.puestoporcolaboradorid = 0;
        if(this.asignacionentidadrepuesto.puestoporcolaboradorid == 0){
            this.activar = false;
        }
        if (e !== '') {
          if(this.sistemaService.permisos.edicionespecial){
            this.SetColaboradoresGrupo(e);
            }else{
            this.SetColaboradoresGrupoDetalle(e);
          }
        }
    }

    SetPuestoSuperiorYInferior(id: number) {
        if (id) {
            this.DataColaboradores = [];
            this.DataColaboradoresComplementarias = [];
            this.listcolaboradores = [];
            this.activar = true;
            //marcado
            this.appService.Post("planeacion/asignacionevaluacion/colaborador/puestos", {"puestoporcolaboradorid": id, "periodoevaluacionportipoevaluacionid": this.accion.entidad.periodoevaluacionportipoevaluacionid}).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.DataColaboradores = res.data.colaboradorjefeysubordinado;
                    this.listcolaboradores = res.data.colaboradorjefeysubordinado;
                    this.DataColaboradoresComplementarias = res.data.colaboradorparycomplementario;

                    this.asignacionentidadrepuesto = new AsignacionEvaluacion(res.data.autoevaluacion[0]);
                }
            })
        } else {
            this.activar = false;
            this.DataColaboradores = [];
            this.DataColaboradoresComplementarias = [];
            this.listcolaboradores = [];
        }
    }

    SetColaboradoresGrupo(id: number) {
        this.appService.Get("planeacion/asignacionevaluacion/colaborador/puestos/" + id).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.listgrupocolaboradores = res.data;
            }
        })
    }

    SetColaboradoresGrupoDetalle(id: number){
      this.appService.Post("planeacion/asignacionevaluacion/colaborador/mipuesto", {"departamentoid":id}).then(res=>{
        if (res.status == RespuestaEstatusEnum.Success) {
          this.listgrupocolaboradores = res.data;
      }
      })
    }

    Modal() {
        if (this.activar) {
            this.colaborador.personaevaluar = this.asignacionentidadrepuesto.colaborador;
            this.colaborador.departamento = this.asignacionentidadrepuesto.departamento;
            this.colaborador.puesto = this.asignacionentidadrepuesto.puesto;
            this.colaborador.seleccionMultiple = true;
            this.colaborador.colaboradorconpuesto = 1;
            this.colaborador.agruparcolaborador = 1;
            this.colaborador.listcolaboradorduplicado.push(...this.listcolaboradores,...this.DataColaboradoresComplementarias);

            this.colaborador.Modal()
        } else {
            this.mensajeService.Alerta(AlertaEnum.Warning, "Selecciona a una persona a evaluar");
        }

    }

    GuardarColaborador(e: any) {
        let entidad = new AsignacionEvaluacion(this.asignacionentidadrepuesto);
        let colaboradores = []
        for (let colaborador of e) {
            let valor = {"colaboradorpadreid": entidad.colaboradorid, "puestopadreid": entidad.puestoid, "periodoevaluacionportipoevaluacionid": this.accion.entidad.periodoevaluacionportipoevaluacionid, "colaboradorid": colaborador.colaboradorid, "puestoid": colaborador.puestoid};
            colaboradores.push(valor);
        }
        this.appService.Post("planeacion/asignacionevaluacion/colaborador/guardarcolaborador", colaboradores).then(res => {
            if (res.status == RespuestaEstatusEnum.Success) {
                this.colaborador.listcolaboradorduplicado = [];
                this.SetPuestoSuperiorYInferior(entidad.puestoporcolaboradorid);
                this.colaborador.CerrarModal();
            }
        })

    }

    Eliminar(e: any) {
        let opciones = this.sistemaService.GetOpcionesEliminar();
        this.mensajeService.Dialogo(DialogoEnum.aviso, '', '¿Estás seguro que quieres eliminar el registro? <br> Esta acción no se podra deshacer.', opciones).then(res => {
            if (res == 1) {
                this.appService.Delete("planeacion/asignacionevaluacion/colaborador/eliminar/" + e.asignacionevaluacioncolaboradorporcolaboradorid).then(res => {
                    if (res.status == RespuestaEstatusEnum.Success) {
                        this.mensajeService.Alerta(AlertaEnum.Success, res.message);
                        this.SetPuestoSuperiorYInferior(this.asignacionentidadrepuesto.puestoporcolaboradorid);
                    }
                })
            }
        })
    }

    Guardar() {
        let entidad = new AsignacionEvaluacion(this.asignacionentidadrepuesto);
        let colaboradores = []
        if (this.DataColaboradoresComplementarias.length > 0) {
            for (let colaborador of this.DataColaboradoresComplementarias) {
                let valor = {"colaboradorpadreid": entidad.colaboradorid, "puestopadreid": entidad.puestoid, "periodoevaluacionportipoevaluacionid": this.accion.entidad.periodoevaluacionportipoevaluacionid, "colaboradorid": colaborador.colaboradorid, "puestoid":colaborador.puestoid ,"colaboradorrelacionid": colaborador.colaboradorrelacionid, "activo": colaborador.activo, "relacion": colaborador.relacion, "asignacionevaluacioncolaboradorporcolaboradorid": colaborador.asignacionevaluacioncolaboradorporcolaboradorid};
                colaboradores.push(valor);
            }
            this.appService.Put("planeacion/asignacionevaluacion/colaborador", colaboradores).then(res => {
                if (res.status == RespuestaEstatusEnum.Success) {
                    this.mensajeService.Alerta(AlertaEnum.Success, res.message);

                    this.asignacionentidadrepuesto.puestoporcolaboradorid = 0;
                    this.SetPuestoSuperiorYInferior(0);
                    //this.Salir();
                }
            })
        } else {
            this.mensajeService.Alerta(AlertaEnum.Warning, "Tienes que seleccionar un colaborador complementario o par para guardar");
        }
    }

    Salir() {
        this.output.next(this.cambio);
    }
}
